export default "__VITE_ASSET__36ab7988__"